<ion-toolbar [mode]="">
  <ion-grid>
    <ion-row>
      <ion-col size="8">
        <ion-item>
          <ion-select
            #workgroupFilterSelect
            slot="end"
            placeholder="Pracovní skupina"
            interface="popover"
            [value]="defaultWorkgroupValue"
            [compareWith]="compareWithFn"
            (ionChange)="workgroupIdFilterSelectChanged($event)"
          >
            <ion-select-option value="">Vše</ion-select-option>
            <ion-select-option *ngFor="let workgroup of workgroups" [value]="workgroup">
              {{ workgroup.name }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>

      <ion-col size="4">
        <ion-item id="smsHubStatusWrapper">
          Stav SMS brány:
          <span *ngIf="{ smsHubConnected: (smsHubConnected$ | async) } as data">
            <span *ngIf="data.smsHubConnected" class="circle-success"></span>
            <span *ngIf="!data.smsHubConnected" class="circle-danger"></span>
          </span>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-toolbar>

<div id="segmentsWrapper">
  <ion-segment #segment (ionChange)="activeTabChange($event)" [value]="activeTab">
    <ion-segment-button value="inbound">Příchozí</ion-segment-button>
    <ion-segment-button value="outbound">Odeslané</ion-segment-button>
  </ion-segment>
  <ion-button pTooltip="Označit všechny jako přečtené" (click)="markAllAsRead()">
    <ion-icon name="mail-open-outline"></ion-icon>
  </ion-button>
</div>

<ion-content>
  <ion-list *ngIf="activeTab === 'inbound'">
    <ion-list-header lines="inset">
      <ion-grid class="msg-item">
        <ion-row class="grid-header">
          <ion-col size="1" class="flex-vertical-center">Směr</ion-col>
          <ion-col size="2" class="flex-vertical-center">Od</ion-col>
          <ion-col size="7">Text</ion-col>
          <ion-col size="2" class="msg-time flex-vertical-center">Přijato</ion-col>
        </ion-row>
      </ion-grid>
    </ion-list-header>

    <ion-item
      *ngFor="let msg of sortedInboundMessages$ | async; let i = index"
      class="msgItem"
      (click)="openMessage(msg)"
      [ngClass]="{ unread: !msg.isReadByCurrentUser() }"
    >
      <ion-grid class="msg-item">
        <ion-row>
          <ion-col size="1" class="flex-vertical-center">
            <span class="msg-from">{{ msg.humanizeDirection() }}</span>
          </ion-col>
          <ion-col size="2" class="flex-vertical-center">
            <span class="msg-from">{{ msg.contact?.user.fullName() }}</span>
          </ion-col>
          <ion-col size="7">
            <span class="msg-content" [innerHTML]="msg.body | stripTags"></span>
          </ion-col>
          <ion-col size="2" class="msg-time flex-vertical-center">
            {{ msg.createdAt | date: 'dd.MM.yyyy HH:mm' }}
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>

    <ion-infinite-scroll #inboundInfiniteScroll threshold="100px" (ionInfinite)="loadMoreInboundData()">
      <ion-infinite-scroll-content
        loadingSpinner="bubbles"
        loadingText="Načítám další SMS..."
      ></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-list>

  <ion-list *ngIf="activeTab === 'outbound'">
    <ion-list-header lines="inset">
      <ion-grid class="msg-item">
        <ion-row class="grid-header">
          <ion-col size="1" class="flex-vertical-center">Směr</ion-col>
          <ion-col size="2" class="flex-vertical-center">Adresát</ion-col>
          <ion-col size="6">Text</ion-col>
          <ion-col size="2" class="msg-time flex-vertical-center">Odesláno</ion-col>
          <ion-col size="1" class="flex-vertical-center">Stav</ion-col>
        </ion-row>
      </ion-grid>
    </ion-list-header>

    <ion-item
      *ngFor="let msg of sortedOutboundMessages$ | async; let i = index"
      class="msgItem"
      (click)="openMessage(msg)"
    >
      <ion-grid class="msg-item">
        <ion-row>
          <ion-col size="1" class="flex-vertical-center">
            <span class="msg-from">{{ msg.humanizeDirection() }}</span>
          </ion-col>
          <ion-col size="2" class="flex-vertical-center">
            <span class="msg-from">{{ msg.contact?.user.fullName() }}</span>
          </ion-col>
          <ion-col size="6">
            <span class="msg-content" [innerHTML]="msg.body | stripTags"></span>
          </ion-col>
          <ion-col size="2" class="msg-time flex-vertical-center">
            {{ msg.createdAt | date: 'dd.MM.yyyy HH:mm' }}
          </ion-col>
          <ion-col size="1" class="flex-vertical-center">
            <span class="status">{{ msg.getStatusHumanized() }}</span>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>

    <ion-infinite-scroll #outboundInfiniteScroll threshold="100px" (ionInfinite)="loadMoreOutboundData()">
      <ion-infinite-scroll-content
        loadingSpinner="bubbles"
        loadingText="Načítám další SMS..."
      ></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-list>
</ion-content>
